import { useTranslation } from 'react-i18next';

export const useAlertUtil = () => {
  const { t } = useTranslation();

  const showAlert = (key: string, params?: Record<string, any>) => {
    alert(t(key, params ?? {}));
  };

  return { showAlert };
};
